module.exports = __webpack_public_path__ + "img/ios.5acfc106.png";